<template>
    <div>
        <div>
            <vue-headful :title="$t('title_store')" description="title" />
        </div>
        <v-container fluid>
            <v-row class="mx-1">
                <TopBar />
            </v-row>
        </v-container>

        <BannersCaousel />
        
        <v-container fluid fill-height>
            <v-row class="mx-1">
                <TabSelector class="ma-sm-0 tab-selector mt-0 mt-sm-3" v-on:new-tab="setTab" v-on:search="setSearch" />
                <Tabs class="px-0" :search="search" :tabSelected="tabSelected" />
            </v-row>
        </v-container>
    </div>
</template>
<script>
import Tabs from '@/components/store/Tabs.vue'
import TabSelector from '@/components/store/TabSelector.vue'
import TopBar from '@/components/home/TopBar.vue'
import BannersCaousel from '@/components/store/BannersCarousel.vue'


export default {
    components: {
        Tabs,
        TabSelector,
        TopBar,
        BannersCaousel,
    },
    data() {
        return {
            search: '',
            tabSelected: 0,            
        }
    },
    methods: {
        setSearch(data) {
            this.search = data.trim()
        },
        setTab(data) {
            this.tabSelected = data
        },
    }
}
</script>
<style lang="scss">
.tab-selector{
    max-width: calc(100vw - 28px);
    @media screen and (max-width: 600px) {
        max-width: calc(100vw - 16px);        
    }
}
</style>